<template>
  <div>
    <div class="head">
      <el-button size="small" type="primary" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
      :data="tableData"
      :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0,0.85)', background: '#fafafa' }"
      style="width: 100%">
        <el-table-column prop="applicantName" label="申报人姓名" width="130px"></el-table-column>
        <el-table-column prop="applicantSex" label="性别" width="130px">
          <template slot-scope="{ row }">
            <span v-if="row.applicantSex === 1">男</span>
            <span v-else-if="row.applicantSex === 2">女</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="applicantDepName" label="部门" width="130px"></el-table-column>
        <el-table-column prop="accidentBulletinName" label="事故名称" width="130px"></el-table-column>
        <el-table-column prop="accidentTime" label="事故发生时间" width="130px">
          <template slot-scope="{ row }">
            {{ row.accidentTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="occupationalInjuryType" label="工伤类型" width="130px"></el-table-column>
        <el-table-column prop="declarationTime" label="申报日期" width="130px">
          <template slot-scope="{ row }">
            {{ row.declarationTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="delayTime" label="损失工时" width="130px"></el-table-column>
        <el-table-column prop="clinicHospital" label="就诊医院" width="130px"></el-table-column>
        <el-table-column prop="diagnosis" label="就诊结果" width="130px"></el-table-column>
        <el-table-column prop="fileName" label="相关附件" width="130px">
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false" @click="download(row.fileUrl,row.fileName)">{{ row.fileName }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="announcements" label="注意事项" width="130px" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isAllReady" label="材料是否齐全" width="130px">
          <template slot-scope="{ row }">
            {{ row.isAllReady === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip width="130px"></el-table-column>
        <el-table-column label="操作" width="120px" fixed="right">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" @click="editBtn(row)">编辑</el-link>
            <span style="padding: 0 8px; color: #e8e8e8">|</span>
            <el-link :underline="false" type="danger" @click="deleteBtn(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
  </div>
</template>

<script>
import { inJuryONJobList, inJuryONJobDelete } from "@/api/processManager"
import { downLoadDocument } from '@/api/downLoad'
export default {
  name: 'InjuryOnTheJob',
  data() {
    return {
      tableData: [],
      limit: 10,
      curPage: 1,
      total: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      inJuryONJobList({ limit: this.limit, curPage: this.curPage, isPage: 1 }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    addBtn() {
      this.$router.push('AddInjuryOnTheJob')
    },
    curPageChange(val) {
      this.curPage = val
      this.getData()
    },
    // 编辑
    editBtn(row) {
      let obj = { ...row }
      for(let i in obj) {
        if(obj[i] === undefined || obj[i] === null || obj[i] === '' || obj[i] === 'null') {
          delete obj[i]
        }
      }
      // console.log(obj)
      // return
      this.$router.push({
        name: 'AddInjuryOnTheJob',
        params: { key: obj }
      })
    },
    // 下载附件
    download(url, name) {
      downLoadDocument(url, name)
    },
    // 删除
    deleteBtn(row) {
      inJuryONJobDelete(row.id).then(res => {
        this.$message.success('删除成功')
        this.getData()
      })
    }
  }
}
</script>

<style scoped>

</style>